import React from "react";

const PriceArticle = () => {
  return (
    <div className="priceArticle pb-20">
      <div className="mx-auto max-w-screen-xl">
        <div className="article grid grid-cols-4 gap-1.5">
          <div className="articleItem">
            <div className="round"></div>
            <div className="itemContent">
              <div className="articleItemTitle mb-2.5">
                <h4>Lorem ipsum</h4>
                <p>(Lorem ipsum dolor)</p>
              </div>
              <p
                style={{ fontSize: "25px", fontWeight: "600" }}
                className="mb-2.5"
              >
                5.000.000đ
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
              </ul>
              <button>Lorem ipsum</button>
            </div>
          </div>
          <div className="articleItem">
            <div className="round">
              <img src={"./img/Group_576.png"} alt="Group_576.png" />
            </div>
            <div className="itemContent">
              <div className="articleItemTitle mb-2.5">
                <h4>Lorem ipsum</h4>
                <p>(Lorem ipsum dolor)</p>
              </div>
              <p
                style={{ fontSize: "25px", fontWeight: "600" }}
                className="mb-2.5"
              >
                5.000.000đ
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
              </ul>
              <button>Lorem ipsum</button>
            </div>
          </div>
          <div className="articleItem">
            <div className="round"></div>
            <div className="itemContent">
              <div className="articleItemTitle mb-2.5">
                <h4>Lorem ipsum</h4>
                <p>(Lorem ipsum dolor)</p>
              </div>
              <p
                style={{ fontSize: "25px", fontWeight: "600" }}
                className="mb-2.5"
              >
                5.000.000đ
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
              </ul>
              <button>Lorem ipsum</button>
            </div>
          </div>
          <div className="articleItem">
            <div className="round"></div>
            <div className="itemContent">
              <div className="articleItemTitle mb-2.5">
                <h4>Lorem ipsum</h4>
                <p>(Lorem ipsum dolor)</p>
              </div>
              <p
                style={{ fontSize: "25px", fontWeight: "600" }}
                className="mb-2.5"
              >
                5.000.000đ
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
                <li>
                  <i className="fa-solid fa-circle"></i>
                  Lorem ipsum dolor
                </li>
              </ul>
              <button>Lorem ipsum</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceArticle;
